module.exports = __webpack_public_path__ + "img/door.9fd08d7b.svg";